var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 225,
    viewBox: "0 0 226 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9223 104.006L42.3723 121.096V66.8163L8.9223 64.9763V104.006Z",
    fill: "#34495E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.122 31.0363C96.6433 31.0358 80.5359 35.9337 66.8466 45.1077C53.1573 54.2817 42.5038 67.3178 36.2396 82.5598C29.9754 97.8018 28.3831 114.562 31.6652 130.711C34.9472 146.86 42.9554 161.669 54.6724 173.256L42.3724 206.506L77.0324 189.056C88.2839 194.485 100.614 197.309 113.107 197.316C125.6 197.324 137.934 194.516 149.192 189.101C160.45 183.685 170.343 175.802 178.136 166.037C185.928 156.273 191.419 144.877 194.201 132.698C196.983 120.519 196.984 107.869 194.204 95.6895C191.425 83.5098 185.935 72.1132 178.145 62.347C170.355 52.5807 160.463 44.6959 149.206 39.2786C137.949 33.8613 125.615 31.0509 113.122 31.0563V31.0363Z",
    fill: "#0C403E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.958 168.327C199.946 137.339 199.946 87.097 168.958 56.1089C137.97 25.1208 87.7281 25.1208 56.74 56.1089C25.7519 87.097 25.7519 137.339 56.74 168.327C87.7281 199.315 137.97 199.315 168.958 168.327Z",
    fill: "#F7B612"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.536 162.59C192.458 132.668 192.458 84.1551 162.536 54.2331C132.614 24.3111 84.1005 24.3111 54.1785 54.2331C24.2566 84.1551 24.2566 132.668 54.1785 162.59C84.1005 192.512 132.614 192.512 162.536 162.59Z",
    fill: "#077B7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.652 68.6463V29.6163L8.9223 64.9763V104.006L147.652 68.6463Z",
    fill: "#E93C4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9223 64.9763V83.8163L147.652 48.4563V29.6163L8.9223 64.9763Z",
    fill: "#D62748"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.932 86.7263L163.732 125.166H208.122L185.932 86.7263Z",
    fill: "#1B1A18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8223 180.806L24.5123 162.946H45.1323L34.8223 180.806Z",
    fill: "#F7B612"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.772 56.1363L200.972 59.2563L192.462 44.5163H196.062L202.772 56.1363Z",
    fill: "#F7B612"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M178.952 44.5163H182.552L196.022 67.8363L194.222 70.9563L178.952 44.5163Z",
    fill: "#F7B612"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M199.392 61.9863L197.592 65.1063L185.702 44.5163H189.312L199.392 61.9863Z",
    fill: "#F7B612"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.972 44.5163H209.482L207.732 47.5563L205.972 44.5163Z",
    fill: "#F7B612"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.642 73.6763L191.312 75.9963L173.132 44.5163H175.802L192.642 73.6763Z",
    fill: "#F7B612"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.152 50.2863L204.352 53.4063L199.212 44.5163H202.822L206.152 50.2863Z",
    fill: "#F7B612"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8724 149.536L30.4924 147.146L23.9724 158.446H26.7324L31.8724 149.536Z",
    fill: "#0C403E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6123 158.446H16.3723L26.7023 140.566L25.3123 138.176L13.6123 158.446Z",
    fill: "#0C403E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2924 145.056L27.9024 142.666L18.7924 158.446H21.5524L29.2924 145.056Z",
    fill: "#0C403E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3323 158.446H37.0223L35.6723 156.116L34.3323 158.446Z",
    fill: "#0C403E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1123 136.086L23.0823 134.316L9.15234 158.446H11.1923L24.1123 136.086Z",
    fill: "#0C403E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4723 154.026L33.0823 151.636L29.1523 158.446H31.9123L34.4723 154.026Z",
    fill: "#0C403E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanDetails);
export default __webpack_public_path__ + "static/media/plan-details.bffe66a06d75e9b58f02554facb941e6.svg";
export { ForwardRef as ReactComponent };